import { Droplet, Syringe, Zap, Heart, TestTube, Wind } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
const servicesData = [{
  title: "Colon Hydrotherapy",
  description: "Colon hydrotherapy is a gentle, water-based wellness treatment designed to help cleanse and hydrate the colon while supporting healthy digestion and the body’s natural detoxification process. Using a hygienic, temperature-controlled system, warm filtered water is used to comfortably flush waste and promote overall gut wellness, hydration, and feelings of lightness and rejuvenation.",
  icon: Droplet
}, {
  title: "Vitamin Injections + IV's",
  description: "Quick, potent boosts for your wellness journey. Our targeted vitamin injections and IV therapies deliver essential nutrients designed to support energy, immunity, hydration, recovery, metabolic function, and overall vitality — helping you feel refreshed, optimized, and recharged in minutes.",
  icon: Syringe
}, {
  title: "GLP's + Peptides",
  description: "GLP-1 and peptide therapies designed to optimize metabolic health, improve weight management, and support overall wellness. Detailed protocol includes dosage, administration schedule, and monitoring guidelines.",
  icon: Zap
}, {
  title: "Hormone Optimization",
  description: "Hormone Optimization is designed to help support balance, energy, mood, metabolism, mental clarity, libido, and overall well-being through personalized wellness solutions tailored to your body’s needs. Our approach may include comprehensive wellness assessments, lab testing, lifestyle guidance, peptide support, vitamin therapies, and customized treatment plans focused on helping you feel optimized, revitalized, and performing at your best.",
  icon: Heart
}, {
  title: "Lab Testing + Nutrition",
  description: "Quick, potent boosts for your wellness journey. Our targeted vitamin injections and IV therapies deliver essential nutrients designed to support energy, immunity, hydration, recovery, metabolic function, and overall vitality — helping you feel refreshed, optimized, and recharged in minutes. We also offer nutrition support through customized meal prep and wellness plans, along with advanced body composition analysis to assess progress, track results, and support your overall health and wellness goals.",
  icon: TestTube
}, {
  title: "Detox + Recovery",
  description: "A comprehensive wellness experience designed to support detoxification, circulation, relaxation, recovery, and overall vitality. This restorative service may include infrared salt sauna therapy, ionic foot detox, vibration platform therapy, PEMF, lymphatic drainage solutions, oxygen therapy, compression recovery, amethyst biomat therapy, and cleansing support to help promote relaxation, reduce stress, support recovery, and leave you feeling refreshed and recharged.",
  icon: Wind
}];
export default function Services() {
  return <section data-section-id="224847" id="our-core-modalities" className="w-full bg-background text-foreground py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center">
          <h2 className="font-default text-4xl font-normal text-foreground md:text-5xl tracking-tight">
            Our Core Modalities
          </h2>
        </div>
        
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {servicesData.map((service, i) => {
          const Icon = service.icon;
          return <Card key={i} data-index={i} className="group rounded-lg border border-white/20 bg-white/40 backdrop-blur-sm transition-all duration-500 hover:bg-white hover:border-white hover:shadow-xl">
                <CardHeader className="pb-4 text-center">
                  <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-muted/50 text-primary transition-transform duration-500 group-hover:scale-110">
                    <Icon className="h-6 w-6" />
                  </div>
                  <CardTitle className="font-default text-2xl font-normal text-primary">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="text-center">
                  <CardDescription className="font-default text-base leading-relaxed text-muted-foreground mb-6">
                    {service.description}
                  </CardDescription>
                  <div className="inline-flex items-center text-xs font-default uppercase tracking-widest text-primary hover:opacity-70 transition-opacity cursor-pointer">
                    Learn More <span className="ml-2">→</span>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}